<template>
    <div>
      <modal-form v-model="show" :submit="submit" size="sm">
        <template v-slot:title>
          <v-icon class="mr-2">fas fa-edit</v-icon>
          {{ model.CodigoSimulacaoGarantia ? "Editar" : "Nova" }} Garantia
        </template>
        <template v-slot:body>
          <v-row>
            <v-col cols="12">
              <input-radiogroup @change="changeTipoPlaca" name="Tipo Placa" v-model="model.TipoPlaca" required row>
                <v-radio v-for="tipoPlaca in $aux.TipoPlaca.filter(item => [1, 2, 3, 6].includes(item.value))" :key="tipoPlaca.value" :value="tipoPlaca.value">
                  <template v-slot:label>
                    <v-tooltip v-if="tipoPlaca.text === 'Outros'" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on" class="mr-2">{{ tipoPlaca.text }}</span>
                      </template>
                      <span>Este campo é destinado a veículos que não constam na Tabela Fipe, como importados,
                        customizados, clássicos, edições limitadas e Outros.
                      </span>
                    </v-tooltip>
                    <span v-else class="mr-2">{{ tipoPlaca.text }}</span>
                  </template>
                </v-radio>
              </input-radiogroup>
            </v-col>
            <v-col cols="12">
              <input-select label="UF Licenciamento"
                            :options="$aux.UF"
                            item-value="UF"
                            item-text="Nome"
                            required
                            v-model="model.UFLicenciamento"
                            @change="getValorRegistro" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" v-if="vlrRegistro">
              <input-text label="Valor do Registro" :value="$api.UI.Format.Decimal(vlrRegistro)" readonly disabled />
            </v-col>
          </v-row>
        </template>
      </modal-form>
    </div>
  </template>
<script>
export default {
  data () {
    return {
      show: false,
      model: {},
      vlrRegistro: 0,
    }
  },
  methods: {
    openModal (sender) {
      const th = this
      th.show = true
      th.model = {} // ver
      th.$set(th, 'vlrRegistro', 0)
      if (sender) {
        th.model = sender
        th.getValorRegistro()
      }
    },
    changeTipoPlaca () {
      const th = this
      th.getValorRegistro()
    },
    getValorRegistro: async function () {
      let vlr = 0
      const taxa = this.$param.EST_VALORES.Registro.find(p => p.Grupo === 2 && p.Subgrupo === 1).Valor || 0
      if (this.model.UFLicenciamento) {
        var gravames = await this.$api.Kraken.GetAllGravames()
        var gravame = gravames.find(p => p.uf === this.model.UFLicenciamento)
        switch (this.model.TipoPlaca) {
          case 1:
            vlr += gravame.valorTipo1
            break
          case 2:
            vlr += gravame.valorTipo2
            break
          case 3:
          case 6:
            vlr += gravame.valorTipo3
            break
        }
      }
      this.$set(this, 'vlrRegistro', (vlr + taxa))
    },
    submit () {
      const th = this
      var data = {
        TipoPlaca: th.model.TipoPlaca,
        UFLicenciamento: th.model.UFLicenciamento,
        VlrRegistro: th.vlrRegistro
      }
      if (th.model.CodigoSimulacaoGarantia) {
        th.$emit('close', 'edit', {
          ...data,
          CodigoSimulacaoGarantia: th.model.CodigoSimulacaoGarantia
        })
      } else {
        th.$emit('close', 'save', {
          ...data,
          CodigoSimulacaoGarantia: th.$api.UI.Guid.New()
        })
      }
      th.show = false
    },
  },
}
</script>
